
export const ROLES = {
  rAdmin : {
    key: 'rAdmin',
    value: 'Administrator',
    color: 'success',
    icon: '',
  },
  rBusiness : {
    key: 'rBusiness',
    value: 'Business',
    color: 'primary',
    icon: '',
  },
  rCandidate : {
    key: 'rCandidate',
    value: 'Candidate',
    color: 'warning',
    icon: '',
  },
}